import Header from "./Header";

// Re-export Header as ProfileNavigation for backward compatibility
export default function ProfileNavigation() {
    return <Header />;
}
